import React from 'react';
import Cookies from 'js-cookie';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Box, Flex, Grid, Spinner, Text } from '@radix-ui/themes';

import Sidebar from 'Components/employersSide/Sidebar';
import { logOutIfTokenExpired } from 'Components/helpers';
import { usePlansPurchase } from './plans-purchase.provider';
import { PlanCard } from './components/plan-card';
import './plans-purchase.scss';

function PlansPurchaseView() {
   const navigate = useNavigate();
   const { t } = useTranslation('global');
   const plansPurchaseStore = usePlansPurchase();

   const primaryColor = Cookies.get('primaryColor') ?? '#f3734c';
   const secondaryColor = Cookies.get('secondaryColor') ?? '#294a9c';
   const currency = Cookies.get('curr') ?? '';

   const handleAuthError = React.useCallback(() => {
      navigate('/');
      logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
   }, [navigate, t]);

   const handleError = React.useCallback(
      (message: string) => {
         toast.error(message || t('membershipPlan.purchaseFailedTitle'));
      },
      [t]
   );

   React.useEffect(() => {
      const userType = Cookies.get('user_type');
      const tokenKey = Cookies.get('tokenClient');

      if (userType === 'candidate' || !tokenKey) {
         navigate('/auth/employer-login');
         return;
      }

      plansPurchaseStore.loadPlans({
         onError: handleError,
         onAuthError: handleAuthError,
      });

      window.scrollTo(0, 0);
   }, [handleAuthError, handleError, navigate, plansPurchaseStore]);

   return (
      <div className="container membershipPlan plansPurchase">
         <div className="row">
            <div className="col-lg-3">
               <Sidebar />
            </div>

            <div className="col-lg-9 mb-5 CLPanelRight">
               <div className="plansPurchaseHeader PageHeader">
                  <Flex align="center" gap="2">
                     <img src="/Images/employerSide/us-dollar-32-color.png" alt="" />
                     <h3>{t('membershipPlan.purchaseMembershipPlan')}</h3>
                  </Flex>
               </div>

               {plansPurchaseStore.loading ? (
                  <Flex justify="center" py="6">
                     <Spinner size="2" />
                  </Flex>
               ) : (
                  <Box mt="5">
                     {plansPurchaseStore.hasPlans ? (
                        <Grid columns={{ initial: '1', md: '2', xl: '3' }} gap="5">
                           {plansPurchaseStore.plans.map((plan) => (
                              <PlanCard
                                 key={plan.plan_id}
                                 plan={plan}
                                 currency={currency}
                                 primaryColor={primaryColor}
                                 secondaryColor={secondaryColor}
                                 onAuthError={handleAuthError}
                                 onError={handleError}
                                 onSuccess={(message) => {
                                    toast.success(message);
                                    navigate('/user/paymenthistory');
                                 }}
                              />
                           ))}
                        </Grid>
                     ) : (
                        <Flex justify="center" py="6">
                           <Text color="gray">{t('pagination.NoofRecords')} 0</Text>
                        </Flex>
                     )}
                  </Box>
               )}
            </div>
         </div>
      </div>
   );
}

export const PlansPurchase = observer(PlansPurchaseView);
